<template>
    <div class="container my-5 text-center" v-if="car">
      <h2>Bedankt voor je aanvraag voor de {{ car.title }}</h2>
      <p>
        {{  this.text }}

      </p>
    </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      car: null,
      text: null
    }
  },
  mounted() {
    let id = this.$route.params.id;
    this.getData(id)
  },
  methods: {
    getData(id) {
      axios.get(window.crcBaseApiUrl+'/thanks/'+ id).then( (response)  => {
        this.car = response.data.car
        this.text = response.data.text
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push({
          'ecommerce': {
            'currencyCode': 'EUR',
            'detail': {
              'actionField': {'list': 'Detail'},
              'products': [{
                'name': this.car.title,        // Name or ID is required.
                'id': this.car.mappeddata.carid,
                'price': this.car.mappeddata.price,
                'brand': this.car.mappeddata.brand,
                'category': '',
                'variant': this.car.mappeddata.description,
                'dimension3': this.car.mappeddata.plate
              }]
            }
          }
        });

        // 'ecommerce': {
          //     'currencyCode': 'EUR',
          //     'detail': {
          //       'actionField': {'list': 'Detail'},
          //       'products': [{
          //         'name': this.car.title,
          //         'id': this.car.mappeddata.carid,
          //         'price': this.car.mappeddata.price,
          //         'brand': this.car.mappeddata.brand,
          //         'category': 'Occasion',
          //         'variant': '1.6 T3 150PK Kinetic BNS | Elec.Stoel + Memory | NAV | ECC | PDC | TREKHAAK |',
          //         'dimension3': this.car.mappeddata.plate
          //       }]
          //     }
      });
    }
  }
}
</script>
